import React, { useState } from 'react';

import Chip from '@gogame/ui/Chip';
import Divider from '@gogame/ui/Divider';
import { ExpandMoreIcon, ExpandLessIcon } from '@gogame/ui/Icon';
import Typography from '@gogame/ui/Typography';
import { makeStyles } from '@gogame/ui/styles';

const useStyles = makeStyles({
  content: {
    display: ({ show }) => (!show ? 'none' : null),
    padding: '0 0 16px',
  },
  divider: {
    margin: '-8px 0',
    padding: '0 16px',
  },
  button: {
    background: 'none',
  },
});

const CollapsibleBlock = ({ children, showLabel, hideLabel }) => {
  const [show, setShow] = useState(true);

  const classes = useStyles({ show });

  const handleShow = () => setShow((state) => !state);

  return (
    <div>
      <div className={classes.content}>{children}</div>
      <Divider className={classes.divider}>
        <Chip
          className={classes.button}
          label={
            <Typography color={'textSecondary'}>
              {show ? hideLabel : showLabel}
            </Typography>
          }
          icon={
            show ? (
              <ExpandLessIcon color={'action'} />
            ) : (
              <ExpandMoreIcon color={'action'} />
            )
          }
          onClick={handleShow}
          size={'small'}
        />
      </Divider>
    </div>
  );
};

export default CollapsibleBlock;
